import { render } from "./exponent.vue?vue&type=template&id=1224c6ec&scoped=true&ts=true"
import script from "./exponent.vue?vue&type=script&lang=ts"
export * from "./exponent.vue?vue&type=script&lang=ts"

import "./exponent.vue?vue&type=style&index=0&id=1224c6ec&lang=less"
import "./exponent.vue?vue&type=style&index=1&id=1224c6ec&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1224c6ec"]])

export default __exports__